// extracted by mini-css-extract-plugin
module.exports = {"quote":"BlogQuote_quote__mNrMu"};